const getMonthString = (months) => {
  if (months % 10 === 1 && months !== 11) return 'месяц';
  if ([2, 3, 4].includes(months % 10) && ![12, 13, 14].includes(months)) return 'месяца';
  return 'месяцев';
};

const getYearString = (years) => {
  if (years % 10 === 1 && years !== 11) return 'год';
  if ([2, 3, 4].includes(years % 10) && ![12, 13, 14].includes(years)) return 'года';
  return 'лет';
};

export default (date: string) => {
  const firstDonationDate = new Date(date);
  const currentDate = new Date();

  let totalMonths = 
    (currentDate.getFullYear() - firstDonationDate.getFullYear()) * 12 +
    (currentDate.getMonth() - firstDonationDate.getMonth());

  if (currentDate.getDate() < firstDonationDate.getDate()) {
    totalMonths--;
  }

  if (totalMonths < 1) {
    return 'Меньше месяца';
  } else if (totalMonths < 12) {
    return `${totalMonths} ${getMonthString(totalMonths)}`;
  } else {
    const years = Math.floor(totalMonths / 12);
    return `${years} ${getYearString(years)}`;
  }
};
